import React from 'react';

import {
  BounceSpinner,
  FoldSpinner,
  LoadingText,
  PulseSpinner,
  RingSpinner,
  RotateSpinner,
  SpinnerWrapper,
} from './styled';
import type { LoadingSpinnerProps } from './types';

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  isLoading = true,
  variant = 'rotate',
  size = 'medium',
  color = 'primary',
  speed = 'normal',
  width,
  height,
  showText = false,
  text = 'Loading...',
  centered = false,
  overlay = false,
  overlayMode = 'fixed',
  overlayColor = 'rgba(255, 255, 255, 0.5)',
  disabled = false,
  ariaLabel,
  className,
  style,
  children,
  ...props
}) => {

  if (!isLoading && !children) {
    return null;
  }

  if (!isLoading && children) {
    return <>{children}</>;
  }

  const spinnerProps = {
    testId: props.testId,
    size,
    color,
    speed,
    width,
    height,
    disabled,
  };

  const renderSpinner = () => {
    switch (variant) {
      case 'pulse':
        return <PulseSpinner {...spinnerProps} />;

      case 'bounce':
        return <BounceSpinner {...spinnerProps} />;

      case 'ring':
        return <RingSpinner {...spinnerProps} />;

      case 'fold':
        return <FoldSpinner {...spinnerProps} />;

      case 'rotate':
      default:
        return <RotateSpinner {...spinnerProps} />;
    }
  };

  return (
    <SpinnerWrapper
      className={className}
      style={style}
      centered={centered}
      overlay={overlay}
      overlayMode={overlayMode}
      overlayColor={overlayColor}
      disabled={disabled}
      role='status'
      aria-label={ariaLabel ?? (showText ? text : 'Loading')}
      aria-live='polite'
      {...props}
    >
      {renderSpinner()}
      {showText && (
        <LoadingText size={size} color={color}>
          {text}
        </LoadingText>
      )}
    </SpinnerWrapper>
  );
};